import { parseISO } from 'date-fns'

// Parses an ISO date string as local midnight — avoids UTC-to-local date shift.
// "2026-05-19" → Date representing 2026-05-19 00:00:00 in local timezone (not UTC).
export const parseLocalDate = (dateStr: string): Date => {
  return parseISO(dateStr.slice(0, 10) + 'T00:00:00')
}
